import axios from 'axios';

// let base = 'http://120.79.232.154:3000'; //此接口和webpack dev-server相同
let base = '';

export const requestLogin = params => {                //用户登录请求
    return axios.post(`${base}/api/login`, params).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getUserList = params => {                    //获取用户信息
    return axios.get(`${base}/api/userData`, { params: params }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getRecommend = params => {                 //获取主页中推荐页面信息
    return axios.get(`${base}/api/getrecommend`, { params: params }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getClassic = params => {                   //获取主页中经典课程信息
    return axios.get(`${base}/api/getclassic`, { params: params }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getExpert = params => {                    //获取主页中行家信息
    return axios.get(`${base}/api/getexpert`, { params: params }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getMajor = params => {                 //获取主页中专业信息
    return axios.get(`${base}/api/getmajor`, { params: params }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getClassify = params => {                  //获取课程分类信息
    return axios.get(`${base}/api/getclassify`, { params: params }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getAllclass = params => {                  //获取全部课程列表
    return axios.get(`${base}/api/getallclass`, { params: params }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const findCourseById = params => {               //通过id查找课程
    return axios.post(`${base}/api/findcoursebyid`, params).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getMatchInfoByID = params => {  //比赛详情
    return axios.post('/api/match/getmatchinfobyid', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getvoterule = params => {  //投票规则
    return axios.post('/api/match/getvoterule', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getMatchList = params => { //比赛列表
    return axios.post('/api/match/getMatchList', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setReadCountByMatchID = params => { //浏览量
    return axios.post('/api/match/setReadCountByMatchID', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getProvinceData = params => { //省份
    return axios.post('/api/base/getProvinceData', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getCityData = params => { //市
    return axios.post('/api/base/getCityData', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getplayerlistbymatchid = params => { //报名列表
    return axios.post('/api/match/getplayerlistbymatchid', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const vote = params => { //投票
    return axios.post('/api/match/vote', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getSignItem = params => { //获取报名项
    return axios.post('/api/match/getSignItem', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getplayersigninfo = params => { //我的资料
    return axios.post('/api/match/getplayersigninfo', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getplayerinfo = params => { //选手资料
    return axios.post('/api/match/getplayerinfo', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmatchad = params => { //选手资料
    return axios.post('/api/match/getmatchad', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmatchreward = params => { //选手收到的打赏
    return axios.post('/api/match/getmatchreward', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const delPlayerPic = params =>{//删除图片
     return axios.post('/api/match/delPlayerPic', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
}
export const setMatchShare = params => {  //比赛分享
    return axios.post('/api/match/setMatchShare', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const updateUserName = params => {  //修改昵称
    return axios.post('/api/user/updateUserName', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const bindPhone = params => {  //绑定手机
    return axios.post('/api/user/bindPhone', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const changePhone = params => {  //换绑手机
    return axios.post('/api/user/changePhone', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setPwd = params => {  //设置密码
    return axios.post('/api/user/setPwd', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const setheaderimg = params => {  //修改头像
    return axios.post('/api/user/setheaderimg', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmyissuematch = params => {  //我发布的比赛
    return axios.post('/api/match/getmyissuematch', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmyjoinmatch = params => { //我参与的比赛
    return axios.post('/api/match/getmyjoinmatch', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const checkGeetest = params => {//
    return  axios.post('/api/base/checkGeetest', {"t":(new Date()).getTime()}, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getArticleCate = params => {//文章类别
    return  axios.post('/api/article/getArticleCate', {"t":(new Date()).getTime()}, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getarticlelist = params => { //所有文章
    return axios.post('/api/article/getarticlelist', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getarticleinfobyid = params => { //文章详情
    return axios.post('/api/article/getarticleinfobyid', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getarticlegoodstatus = params => { //获取文章是否点赞
    return axios.post('/api/article/getarticlegoodstatus', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getMyIssueArticle = params => { //我发布的文章
    return axios.post('/api/article/getMyIssueArticle', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getMyShareArticle = params => { //我转发的文章
    return axios.post('/api/article/getMyShareArticle', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getusercenterdata = params => { //文章_他的主页
    return axios.post('/api/user/getusercenterdata', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getshareinfo = params =>{//一键转发文章
    return axios.post('/api/article/getshareinfo ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setarticleshare = params =>{//转发文章
    return axios.post('/api/article/setarticleshare ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setreadcountbyarticleid = params =>{//文章阅读数
    return axios.post('/api/article/setreadcountbyarticleid ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setArticleGood = params =>{//文章点赞
    return axios.post('/api/article/setArticleGood ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const checkmark  = params => { //是否关注
    return axios.post('/api/user/checkmark ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const markuser  = params => { //关注
    return axios.post('/api/user/markuser ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const unmarkuser  = params => { //取消关注
    return axios.post('/api/user/unmarkuser ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getusermarkdata  = params => { //用户关注
    return axios.post('/api/user/getusermarkdata ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getuserfansdata  = params => { //用户粉丝
    return axios.post('/api/user/getuserfansdata ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setcontactinfo  = params => { //修改联系人信息
    return axios.post('/api/user/setcontactinfo ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setorginfo  = params => { //修改机构信息
    return axios.post('/api/user/setorginfo ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getalbuminfo = params => { //获取专辑信息
    return axios.post('/api/article/getalbuminfo', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const getalbumarticlelist = params => { //获取专辑信息
    return axios.post('/api/article/getalbumarticlelist', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setReadCountByAlbumID = params => { //浏览量
    return axios.post('/api/article/setReadCountByAlbumID', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const setAlbumShare = params => {  //比赛分享
    return axios.post('/api/article/setAlbumShare', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getactivitycate = params=>{//活动分类
    return axios.post('/api/Activity/getactivitycate',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getActivityList = params=>{//所有活动
    return axios.post('/api/Activity/getActivityList',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getactivityinfobyid = params=>{//活动详情
    return axios.post('/api/Activity/getactivityinfobyid',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const ActivitygetShareInfo = params=>{//一键转发活动
    return axios.post('/api/Activity/getShareInfo',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getactivitygoodstatus = params=>{//活动点赞否？
    return axios.post('/api/Activity/getactivitygoodstatus',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setactivitygood = params=>{//活动点赞
    return axios.post('/api/Activity/setactivitygood',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setreadcountbyactivityid = params=>{//活动点赞
    return axios.post('/api/Activity/setreadcountbyactivityid',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getsignlist = params=>{//活动报名列表
    return axios.post('/api/Activity/getsignlist',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getsignstatus = params=>{//活动报名状态
    return axios.post('/api/Activity/getsignstatus',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getActivitysignitem = params=>{//活动报名项
    return axios.post('/api/Activity/getsignitem',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getpayitem = params=>{//活动报名票种
    return axios.post('/api/Activity/getpayitem',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getticketlist = params=>{//我的票券
    return axios.post('/api/Activity/getticketlist',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getticketinfo = params=>{//票券详情
    return axios.post('/api/Activity/getticketinfo',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getTicketStatus = params=>{//刷新票券状态
    return axios.post('/api/Activity/getTicketStatus',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const checkticket = params=>{//工作人员验票接口
    return axios.post('/api/Activity/checkticket',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getCheckTicketInfo = params=>{//获取验票票券详情
    return axios.post('/api/Activity/getCheckTicketInfo',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmysignlist = params=>{//我的报名
    return axios.post('/api/Activity/getmysignlist',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmysigninfo = params=>{//我的报名详情
    return axios.post('/api/Activity/getmysigninfo',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const cancelsign = params=>{//取消报名
    return axios.post('/api/Activity/cancelsign',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setactivityshare = params=>{//转发活动
    return axios.post('/api/Activity/setactivityshare',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getpayorderinfo = params=>{// 获取订单支付信息
    return axios.post('/api/Activity/getpayorderinfo',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmyorderlist = params=>{// 我的订单列表
    return axios.post('/api/Activity/getmyorderlist',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const getwxpayorder = params=>{// 支付订单
    return axios.post('/api/Activity/getwxpayorder',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const sign = params=>{// 活动报名
    return axios.post('/api/Activity/sign',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getactisneedlogin = params=>{// 活动是否需要登录
    return axios.post('/api/Activity/getactisneedlogin',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getinteractinfobyid = params=>{// 现场互动
    return axios.post('/api/interact/getinteractinfobyid',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const checksigninstatus  = params=>{// 现场互动
    return axios.post('/api/interact/checksigninstatus ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmsglist  = params=>{// 弹幕列表
    return axios.post('/api/interact/getmsglist ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const sendmsg  = params=>{//发送弹幕
    return axios.post('/api/interact/sendmsg ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getwinnerlist  = params=>{//中奖名单
    return axios.post('/api/interact/getwinnerlist ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getwinnerdetails  = params=>{//中奖详情
    return axios.post('/api/interact/getwinnerdetails ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const signin  = params=>{//互动签到
    return axios.post('/api/interact/signin ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getVoteItem  = params=>{//互动签到
    return axios.post('/api/interact/getVoteItem ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const interactVote  = params=>{//互动签到
    return axios.post('/api/interact/Vote ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getvippayorder  = params=>{//获取用户升级/续费预付订单
    return axios.post('/api/user/getvippayorder ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmyissueact  = params=>{//我发布的活动
    return axios.post('/api/activity/getmyissueact ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmyshareact  = params=>{//我转发的活动
    return axios.post('/api/activity/getmyshareact ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getactinfobyid  = params=>{//活动信息
    return axios.post('/api/activity/getactinfobyid ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getactsignlist  = params=>{//活动报名名单
    return axios.post('/api/activity/getactsignlist ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const PassActSign  = params=>{//通过活动报名
    return axios.post('/api/activity/PassActSign ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const ReturnActSign = params=>{//退回活动报名
     return axios.post('/api/activity/ReturnActSign ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getactqrcode = params=>{//获得活动二维码
     return axios.post('/api/activity/getactqrcode ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const RemoveAct = params=>{//删除活动
     return axios.post('/api/activity/RemoveAct ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getactshorturl = params=>{//活动短链接
     return axios.post('/api/activity/getactshorturl ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getcheckinpostertemplate = params=>{//活动签到海报模板
     return axios.post('/api/activity/getcheckinpostertemplate ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getcheckinposter = params=>{//活动签到海报模板
     return axios.post('/api/qrcode/getcheckinposter ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const unbindwx = params=>{//解绑微信
     return axios.post('/api/user/unbindwx ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getdrawbank  = params=>{//获取微信提现支持银行列表
    return axios.post('/api/base/getdrawbank ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const setdrawbank  = params=>{//设置用户提现银行信息
    return axios.post('/api/user/setdrawbank ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const getuserprofit  = params=>{//获取用户收益信息
    return axios.post('/api/user/getuserprofit ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const drawuserprofit  = params=>{//用户提现
    return axios.post('/api/user/drawuserprofit ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const getuserdrawlist  = params=>{//获取用户提现列表
    return axios.post('/api/user/getuserdrawlist ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const getuserprofitlist  = params=>{//获取用户收益列表
    return axios.post('/api/user/getuserprofitlist ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getticketlistbyactid  = params=>{//用户签到_获取全部票券
    return axios.post('/api/Activity/getticketlistbyactid ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const checkinticket  = params=>{//用户签到
    return axios.post('/api/Activity/checkinticket ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getInvitePoster  = params=>{//生成推广二维码
    return axios.post('/api/qrcode/getInvitePoster ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmyshareactinfo  = params=>{//我装发的活动信息
    return axios.post('/api/Activity/getmyshareactinfo ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmyshareactsignlist  = params=>{//我装发的活动报名列表
    return axios.post('/api/Activity/getmyshareactsignlist ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getsharepostertemplate  = params=>{//邀请海报模板
    return axios.post('/api/Activity/getsharepostertemplate ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getshareposter  = params=>{//生成邀请海报
    return axios.post('/api/qrcode/getshareposter ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getcustomabstract  = params=>{//获取个性化摘要
    return axios.post('/api/Activity/getcustomabstract ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setcustomabstract  = params=>{//设置个性化摘要
    return axios.post('/api/Activity/setcustomabstract ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setsharereport  = params=>{//群发转发
    return axios.post('/api/Activity/setsharereport ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getActReward = params => { //活动的打赏
    return axios.post('/api/Activity/getActReward', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getArticleReward = params => { //文章的打赏
    return axios.post('/api/article/getArticleReward', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const sendcomment = params => { //发送评论
    return axios.post('/api/Base/sendcomment', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getcommentlist  = params => { //评论列表
    return axios.post('/api/Base/getcommentlist ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getcommentinfo  = params => { //评论详情
    return axios.post('/api/Base/getcommentinfo ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const replycomment  = params => { //回复评论
    return axios.post('/api/Base/replycomment ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setcommentstatus  = params => { //审核评论
    return axios.post('/api/Base/setcommentstatus ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const delcomment  = params => { //删除评论
    return axios.post('/api/Base/delcomment ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getbannerlist  = params => { //获得系统轮播图
    return axios.post('/api/Base/getbannerlist ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const actchange  = params => { //活动变更
    return axios.post('/api/act/actchange ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getCommentListByUserCode  = params => { //消息列表
    return axios.post('/api/Base/getCommentListByUserCode ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const resetpwd  = params => { //找回密码
    return axios.post('/api/user/resetpwd ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getcitydatabyprovincecode  = params => {//
    return  axios.post('/api/base/getcitydatabyprovincecode ',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getareadatabycitycode  = params => {//
    return  axios.post('/api/base/getareadatabycitycode ',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const getactbaseinfo  = params => {//获取活动基本信息
    return  axios.post('/api/activity/getactbaseinfo ',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const updateact  = params => {//修改活动基本信息
    return  axios.post('/api/activity/updateact ',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setactivitylogo  = params => {//上传图片
    return  axios.post('/api/activity/setactivitylogo ',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const returnticket  = params => {//票券退回
    return  axios.post('/api/activity/returnticket',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const returnticketbyactid  = params => {//票券退回
    return  axios.post('/api/activity/returnticketbyactid',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
/*早起打卡相关接口*/
export const checkjoin  = params => {//检查是否参加早起打卡
    return  axios.post('/api/Clockin/checkjoin',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const Clockinjoin  = params => {//参加早起打卡
    return  axios.post('/api/Clockin/join',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmyclockin  = params => {//我的打卡
    return  axios.post('/api/Clockin/getmyclockin',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmyclockindetails  = params => {//打卡历史 日历
    return  axios.post('/api/Clockin/getmyclockindetails',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const repairclockin  = params => {//补签
    return  axios.post('/api/Clockin/repairclockin',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getrepaircard  = params => {//补签卡列表
    return  axios.post('/api/Clockin/getrepaircard',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getrepaircardcount  = params => {//我的补签卡剩余
    return  axios.post('/api/Clockin/getrepaircardcount',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const clockin  = params => {//打卡
    return  axios.post('/api/Clockin/clockin',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const clockindetailsrank  = params => {//打卡今日排行
    return  axios.post('/api/Clockin/clockindetailsrank',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setdetailsgood  = params => {//给今日排行点赞
    return  axios.post('/api/Clockin/setdetailsgood',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const clockinrank  = params => {//打卡总排行
    return  axios.post('/api/Clockin/clockinrank',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setrankgood  = params => {//给总排行点赞
    return  axios.post('/api/Clockin/setrankgood',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setremind  = params => {//设置微信提醒
    return  axios.post('/api/Clockin/setremind',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getremind  = params => {//获取微信提醒
    return  axios.post('/api/Clockin/getremind',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getposttemplate  = params => {//获取海报模板
    return  axios.post('/api/Clockin/getposttemplate',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getClockinPoster  = params => {//生成早起打卡海报
    return  axios.post('/api/qrcode/getClockinPoster',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getshareprofit  = params => {//获得打卡收益
    return  axios.post('/api/Clockin/getshareprofit',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getclockinprofit  = params => {//我的打卡收益
    return  axios.post('/api/Clockin/getclockinprofit',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getprofitlist  = params => {//我的打卡收益明细
    return  axios.post('/api/Clockin/getprofitlist',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const transprofit  = params => {//收益转出
    return  axios.post('/api/Clockin/transprofit',params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const getgroupbuyinfobyid = params=>{//获取团购主页面信息接口
    return axios.post('/api/groupbuy/getgroupbuyinfobyid',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const getteamlist = params=>{//获取开团列表接口
    return axios.post('/api/groupbuy/getteamlist',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const checkcaptainauth = params=>{//获取开团资格接口
    return axios.post('/api/groupbuy/checkcaptainauth',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};


export const setcaptainauth = params=>{//提交团长认证接口
    return axios.post('/api/Groupbuy/setcaptainauth',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setapply = params=>{//提交团长开团申请接口
    return axios.post('/api/Groupbuy/setapply',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getcaptaininfo = params=>{//获取团长认证信息接口
    return axios.post('/api/Groupbuy/getcaptaininfo',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getgroupbuyinfobyteam = params=>{// 获取社区团购页面信息接口
    return axios.post('/api/Groupbuy/getgroupbuyinfobyteam',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getteamsignlist = params=>{// getteamsignlist 获取团购活动报名列表接口
    return axios.post('/api/Groupbuy/getteamsignlist',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getsignitembyteam = params=>{// getsignitembyteam 获取团购活动报名项接口
    return axios.post('/api/Groupbuy/getsignitembyteam',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getpayitembyteam = params=>{// getpayitembyteam 获取团购活动套餐项接口
    return axios.post('/api/Groupbuy/getpayitembyteam',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const jointeam = params=>{// 报名参加团购接口
    return axios.post('/api/Groupbuy/jointeam',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const groupbuy_getpayorderinfo = params=>{// 获取订单支付信息接口
    return axios.post('/api/Groupbuy/getpayorderinfo',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const groupbuy_getwxpayorder = params=>{// 获取订单微信支付信息接口
    return axios.post('/api/Groupbuy/getwxpayorder',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setordercancel = params=>{// 取消订单接口（订单状态是未支付时候可以取消订单）
    return axios.post('/api/Groupbuy/setordercancel',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmyteam = params=>{// 获取我的团的接口
    return axios.post('/api/Groupbuy/getmyteam',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const groupbuy_getmyorderlist = params=>{// 我的订单列表
    return axios.post('/api/Groupbuy/getmyorderlist',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setorderrefund = params=>{// 订单退款
    return axios.post('/api/Groupbuy/setorderrefund',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getsignlistbyteam = params=>{// 团报名名单
    return axios.post('/api/Groupbuy/getsignlistbyteam',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getgroupbuylist = params=>{// 团购广场
    return axios.post('/api/Groupbuy/getgroupbuylist',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const setreadcountbyid = params=>{// 团购阅读量
    return axios.post('/api/Groupbuy/setreadcountbyid',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmanager = params=>{// 活动管理员
    return axios.post('/api/Groupbuy/getmanager',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getonechilddata  = params => { //获得一级团队数据
    return axios.post('/api/user/getonechilddata ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const gettwochilddata  = params => { //获得二级团队数据
    return axios.post('/api/user/gettwochilddata ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const checksubscribe  = params => { //获得二级团队数据
    return axios.post('/api/wx/checksubscribe ', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getluckywheel = params => { //获得二级团队数据
    return axios.post('/api/luckywheel/getluckywheelinfo', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getmyluckywheel = params => { //获得二级团队数据
    return axios.post('/api/luckywheel/getmyluckywheel', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};
export const getluckywheelresult = params => { //获得二级团队数据
    return axios.post('/api/luckywheel/getluckywheelresult', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const getuservotecount = params => { //获得二级团队数据
    return axios.post('/api/match/getuservotecount', params, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};

export const testsxf  = params=>{//获取用户升级/续费预付订单
    return axios.post('/api/user/testsxf ',params,{
        headers:{
            'Content-Type': 'application/json'
        }
    }).then(res => {
        return res.data;
    }, err => {
        reject(err);
    }).catch((error) => {
        reject(error)
    });
};



// WEBPACK FOOTER //
// ./src/api/api.js